<template>
    <ion-toolbar>
      <ion-title>My Profile</ion-title>
    </ion-toolbar>
  
    <div class="main_wrapper ion-padding">
      <div class="user_info_wrapper page_padding_top container">
        <div class="image_text_comp">
          <el-button type="transparent" class="image_wrapper" @click="links.changePhoto" data-testid="avatar-btn">
            <el-avatar :size="'medium'" :shape="user.role == 'locum' || user.role == 'agency'  ? 'circle' : 'square'"
              :src="user.image" v-if="user.image" />
            <el-avatar :size="'medium'" :shape="user.role == 'locum' || user.role == 'agency'  ? 'circle' : 'square'"
              icon="el-icon-user-solid" v-else></el-avatar>
            <!-- <span class="locumate_icons locumate_icon-camera"></span> -->
            <span class="locumate_icons">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.76017 22H17.2402C20.0002 22 21.1002 20.31 21.2302 18.25L21.7502 9.99C21.8902 7.83 20.1702 6 18.0002 6C17.3902 6 16.8302 5.65 16.5502 5.11L15.8302 3.66C15.3702 2.75 14.1702 2 13.1502 2H10.8602C9.83017 2 8.63017 2.75 8.17017 3.66L7.45017 5.11C7.17017 5.65 6.61017 6 6.00017 6C3.83017 6 2.11017 7.83 2.25017 9.99L2.77017 18.25C2.89017 20.31 4.00017 22 6.76017 22Z"
                  stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10.5 8H13.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M12 18C13.79 18 15.25 16.54 15.25 14.75C15.25 12.96 13.79 11.5 12 11.5C10.21 11.5 8.75 12.96 8.75 14.75C8.75 16.54 10.21 18 12 18Z"
                  stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
  
          </el-button>
          <div class="text_wrapper">
            <div class="main_text">{{ user.name }}</div>
            <div class="additional_text">
              {{ $filters.addressText(user.address) }}
            </div>
            
            <el-button type="link" class="update_profile" @click="links.changeProfile"
              data-testid="update-details-btn">
              <span>Update Details</span>
            </el-button>
          </div>
        </div>
  
        <div class="settings-separator" ></div>
        <div class="settings_menu">
          <div class="menu_title">Settings</div>
          <div>
           
            <el-button type="transparent" class="menu_item" @click="links.changeProfile" data-testid="account-btn">
              <!-- <span class="locumate_icons locumate_icon-gear"></span> -->
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.0007 10.0003C12.3018 10.0003 14.1673 8.13485 14.1673 5.83366C14.1673 3.53247 12.3018 1.66699 10.0007 1.66699C7.69946 1.66699 5.83398 3.53247 5.83398 5.83366C5.83398 8.13485 7.69946 10.0003 10.0007 10.0003Z"
                  stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M16.0085 13.1162L13.0585 16.0662C12.9418 16.1829 12.8335 16.3995 12.8085 16.5579L12.6502 17.6828C12.5919 18.0912 12.8752 18.3745 13.2835 18.3162L14.4085 18.1579C14.5668 18.1329 14.7919 18.0245 14.9002 17.9079L17.8502 14.9579C18.3585 14.4495 18.6002 13.8579 17.8502 13.1079C17.1085 12.3662 16.5169 12.6079 16.0085 13.1162Z"
                  stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path d="M15.584 13.541C15.834 14.441 16.534 15.141 17.434 15.391"
                  stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M2.8418 18.3333C2.8418 15.1083 6.05015 12.5 10.0002 12.5C10.8668 12.5 11.7001 12.625 12.4751 12.8583"
                  stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
  
  
              <div class="text_wrapper">
                <div class="main_text">Account</div>
                <div class="additional_text">Update your account settings</div>
              </div>
            </el-button>
  
            <el-button type="transparent" class="menu_item" data-testid="notifications-btn" @click="links.notifications">
              <!-- <i class="locumate_icons locumate_icon-notification_bell"></i> -->
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.0165 2.42578C7.25816 2.42578 5.0165 4.66745 5.0165 7.42578V9.83412C5.0165 10.3424 4.79983 11.1174 4.5415 11.5508L3.58316 13.1424C2.9915 14.1258 3.39983 15.2174 4.48316 15.5841C8.07483 16.7841 11.9498 16.7841 15.5415 15.5841C16.5498 15.2508 16.9915 14.0591 16.4415 13.1424L15.4832 11.5508C15.2332 11.1174 15.0165 10.3424 15.0165 9.83412V7.42578C15.0165 4.67578 12.7665 2.42578 10.0165 2.42578Z"
                  stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                  stroke-linecap="round" />
                <path
                  d="M11.5584 2.66719C11.3001 2.59219 11.0334 2.53385 10.7584 2.50052C9.95843 2.40052 9.19176 2.45885 8.4751 2.66719C8.71676 2.05052 9.31676 1.61719 10.0168 1.61719C10.7168 1.61719 11.3168 2.05052 11.5584 2.66719Z"
                  stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M12.5166 15.8828C12.5166 17.2578 11.3916 18.3828 10.0166 18.3828C9.33327 18.3828 8.69993 18.0995 8.24993 17.6495C7.79993 17.1995 7.5166 16.5661 7.5166 15.8828"
                  stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" />
              </svg>
  
  
              <div class="text_wrapper">
                <div class="main_text">Notifications</div>
                <div class="additional_text">
                  Change notification options
                </div>
              </div>
            </el-button>
            <a :href="supportLink" target="_blank" class="el-button el-button--transparent menu_item"
              data-testid="support-btn">
              <!-- <span class="locumate_icons locumate_icon-support"></span> -->
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18.3077 15.2753C18.3077 15.5753 18.241 15.8837 18.0993 16.1837C17.9577 16.4837 17.7744 16.767 17.5327 17.0337C17.1244 17.4837 16.6743 17.8087 16.166 18.017C15.666 18.2253 15.1244 18.3337 14.541 18.3337C13.691 18.3337 12.7827 18.1337 11.8243 17.7253C10.866 17.317 9.90768 16.767 8.95768 16.0753C7.99935 15.3753 7.09102 14.6003 6.22435 13.742C5.36602 12.8753 4.59102 11.967 3.89935 11.017C3.21602 10.067 2.66602 9.11699 2.26602 8.17533C1.86602 7.22533 1.66602 6.31699 1.66602 5.45033C1.66602 4.88366 1.76602 4.34199 1.96602 3.84199C2.16602 3.33366 2.48268 2.86699 2.92435 2.45033C3.45768 1.92533 4.04102 1.66699 4.65768 1.66699C4.89102 1.66699 5.12435 1.71699 5.33268 1.81699C5.54935 1.91699 5.74102 2.06699 5.89102 2.28366L7.82435 5.00866C7.97435 5.21699 8.08268 5.40866 8.15768 5.59199C8.23268 5.76699 8.27435 5.94199 8.27435 6.10033C8.27435 6.30033 8.21602 6.50033 8.09935 6.69199C7.99102 6.88366 7.83268 7.08366 7.63268 7.28366L6.99935 7.94199C6.90768 8.03366 6.86602 8.14199 6.86602 8.27533C6.86602 8.34199 6.87435 8.40033 6.89102 8.46699C6.91602 8.53366 6.94102 8.58366 6.95768 8.63366C7.10768 8.90866 7.36602 9.26699 7.73268 9.70033C8.10768 10.1337 8.50768 10.5753 8.94102 11.017C9.39102 11.4587 9.82435 11.867 10.266 12.242C10.6993 12.6087 11.0577 12.8587 11.341 13.0087C11.3827 13.0253 11.4327 13.0503 11.491 13.0753C11.5577 13.1003 11.6243 13.1087 11.6993 13.1087C11.841 13.1087 11.9493 13.0587 12.041 12.967L12.6743 12.342C12.8827 12.1337 13.0827 11.9753 13.2743 11.8753C13.466 11.7587 13.6577 11.7003 13.866 11.7003C14.0243 11.7003 14.191 11.7337 14.3743 11.8087C14.5577 11.8837 14.7494 11.992 14.9577 12.1337L17.716 14.092C17.9327 14.242 18.0827 14.417 18.1743 14.6253C18.2577 14.8337 18.3077 15.042 18.3077 15.2753Z"
                  stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" />
                <path
                  d="M15.4167 7.50065C15.4167 7.00065 15.025 6.23398 14.4417 5.60898C13.9083 5.03398 13.2 4.58398 12.5 4.58398"
                  stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M18.3324 7.50033C18.3324 4.27533 15.724 1.66699 12.499 1.66699"
                  stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
  
  
              <div class="text_wrapper">
                <div class="main_text">Support</div>
                <div class="additional_text">Contact the Support Team</div>
              </div>
            </a>
            <el-button type="transparent" class="menu_item" data-testid="about-btn" @click="links.goToCommonAbout">
              <!-- <span class="locumate_icons locumate_icon-question_circle"></span> -->
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.1666 15.3584H10.8333L7.12495 17.825C6.57495 18.1917 5.83329 17.8001 5.83329 17.1334V15.3584C3.33329 15.3584 1.66663 13.6917 1.66663 11.1917V6.19169C1.66663 3.69169 3.33329 2.02502 5.83329 2.02502H14.1666C16.6666 2.02502 18.3333 3.69169 18.3333 6.19169V11.1917C18.3333 13.6917 16.6666 15.3584 14.1666 15.3584Z"
                  stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M10 9.46667V9.29171C10 8.72504 10.35 8.42503 10.7 8.18336C11.0417 7.95003 11.3833 7.65004 11.3833 7.10004C11.3833 6.33337 10.7667 5.71667 10 5.71667C9.23334 5.71667 8.6167 6.33337 8.6167 7.10004"
                  stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M9.99629 11.4584H10.0038" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <div class="text_wrapper">
                <div class="main_text">About</div>
              </div>
            </el-button>
            <div class="settings-separator mt-0"></div>
            <div class="d-flex justify-center">
  
              <el-button type="transparent" class="logout" @click="links.logout" data-testid="logout-btn">
                <!-- <span class="locumate_icons locumate_icon-close"></span> -->
                <div class="text_wrapper">
                  <div class="main_text">Logout</div>
                </div>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, onMounted, inject } from "vue";
  
  import { addIcons } from "ionicons";
  import { arrowBackOutline } from "ionicons/icons";
  
  addIcons({
    "arrow-back-outline": arrowBackOutline,
  });
  import { IonToolbar, IonTitle } from "@ionic/vue";
  
  import { useStore } from "vuex";
  
  import { useRouter } from "vue-router";
  
  import { ElMessageBox } from "@/components/Vendor/Element";
  
  import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
  
  
  export default {
    components: {
      IonToolbar,
      IonTitle,
    },
    directives: {},
    setup() {
      let supportLink = ref(null);
      const $store = useStore();
      const $router = useRouter();
      const setPageClassGlobal = inject("setPageClassGlobal");
      const mainMenuShow = inject("mainMenuShow");
      const isAustralia = isAustraliaRegion();
      const message = inject('messages');
  
      const user = $store.getters.GET_USER_DATA;
  
    
      /* @todo preferredLocumEnabled will be available from the api */
      if (user.preferredLocumEnabled === undefined) {
        user.preferredLocumEnabled = 1;
      }
  
      if (user.guestLocumEnabled === undefined) {
        user.guestLocumEnabled = 1;
      }
      
      const regex = /http:\/\/|https:\/\//gm;
      supportLink.value = user.supportSite.replace(regex, "");
      supportLink = `https://${supportLink.value}`;
  
      const registrationNumberMessage =  () => {
          if (process.env.VUE_APP_REGION === "AU") {
           return "Please indicate APHRA number";
          } else {
            return "Please indicate registration number";
  
          }
        }
  
      const links = {
        changeProfile: () => {
          $router.push({
            name: "employer_profile_edit",
          });
        },
       
        changePhoto: () => {
          $router.push({
            name: "profile_photo",
          });
        },
        notifications: () => {
          $router.push({
            name: "profile_notifications",
          });
        },
        goToCommonAbout: () => {
          $router.push({
            name: "common_about",
          });
        },
        logout: () => {
          (async () => {
            try {
              await ElMessageBox.confirm(
                ``,
                "Are you sure you want to log out?",
                {
                  distinguishCancelAndClose: true,
                  showConfirmButton: true,
                  confirmButtonText: "Logout",
                  cancelButtonText: "Cancel",
                  confirmButtonClass: "el-button--green",
                  cancelButtonClass: "el-button--grey",
                  showClose: true,
                }
              );
            } catch {
              return;
            }
            try {
              await $store.dispatch("AUTH_LOGOUT");
            } catch (error) {
              console.log(error);
            }
          })();
        },
      };
  
      onMounted(() => {
        setPageClassGlobal("global_profile_page");
        mainMenuShow(true);
      });
  
      console.log("agency profile", user);
  
      return {
        user,
        supportLink,
        links,
        isAustralia,
        registrationNumberMessage,
        message
      };
    },
  };
  </script>
  
  <style scoped lang="scss">
  .text_wrapper_shift {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 0.5rem;
    .main_text_shift {
      color: rgb(121, 121, 121);
      font-size: 1.1rem;
      font-weight: 500;
    }
  
    .additional_text_shift {
      font-size: 1.2rem;
      font-weight: 400;
      text-align: center;
      display: block;
    }
  }
  </style>
  